module.exports = __webpack_public_path__ + "img/sales2.f366b348.jpg";